import { connect } from 'react-redux';
import {
  getGlobalFilterClauses,
  getGlobalFilterConcatOperator,
  getGlobalFilterEvent,
  getMetainf,
  getProjectZoneId,
} from '../../reducers/analyticsApp';
import {
  addFilterClause,
  removeFilter,
  removeFilterClause,
  setClausesConcatOperator,
  setFilterClauseOperator,
  setFilterClauseField,
  setFilterClauseValue,
} from '../../actions/globalFilter';
import FilterModal from '../../components/common/FilterModal';

const mapStateToProps = (state) => {
  const event = getGlobalFilterEvent(state);

  return {
    concatOperator: getGlobalFilterConcatOperator(state),
    clauses: getGlobalFilterClauses(state),
    metainf: getMetainf(state, event),
    zoneId: getProjectZoneId(state),
  };
};

export default connect(mapStateToProps, {
  onSetClausesConcatOperator: setClausesConcatOperator,
  onAddFilterClause: addFilterClause,
  onRemoveFilter: removeFilter,
  onRemoveFilterClause: removeFilterClause,
  onSelectFilterClauseField: setFilterClauseField,
  onSelectFilterClauseOperator: setFilterClauseOperator,
  onFilterClauseValueChange: setFilterClauseValue,
})(FilterModal);
